'use strict';
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ../shortid/index.js
// module id = 561
// module chunks = 22